import React, { useState } from "react";
import { sendContactMessage } from "../utils/api";

function ContactUs({ setBanner }) {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [status, setStatus] = useState(null);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const validateEmail = (email) => {
    // ✅ Simple regex for email validation
    return /\S+@\S+\.\S+/.test(email);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("loading");

    if (!validateEmail(formData.email)) {
      setStatus("error");
      setBanner?.({
        type: "danger",
        message: "Please enter a valid email address.",
      });
      return;
    }

    try {
      const data = await sendContactMessage(formData);
      setStatus("success");
      setFormData({ name: "", email: "", message: "" });
      setBanner?.({
        type: "success",
        message: data.message || "Message sent successfully!",
      });
    } catch (err) {
      console.error(err);
      setStatus("error");
      setBanner?.({
        type: "danger",
        message: "Server error occurred while sending message.",
      });
    }
  };

  return (
    <div className="container mt-5 pt-4">
      <h2>Contact Us</h2>
      <form
        onSubmit={handleSubmit}
        className="mt-3 mx-auto"
        style={{ maxWidth: "600px" }}
      >
        <div className="mb-3">
          <label className="form-label">Name</label>
          <input
            type="text"
            name="name"
            className="form-control"
            value={formData.name}
            onChange={handleChange}
            required
            placeholder="Enter your name"
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Email</label>
          <input
            type="email"
            name="email"
            className="form-control"
            value={formData.email}
            onChange={handleChange}
            required
            placeholder="Enter your email"
          />
        </div>
        <div className="mb-3">
          <label className="form-label">Message</label>
          <textarea
            name="message"
            className="form-control"
            rows="5"
            value={formData.message}
            onChange={handleChange}
            required
            placeholder="Write your message here..."
          ></textarea>
        </div>
        <button
          type="submit"
          className="btn btn-primary w-100"
          disabled={status === "loading"}
        >
          {status === "loading" ? "Sending..." : "Send"}
        </button>
      </form>

      {/* ✅ Inline feedback */}
      {status === "success" && (
        <p className="mt-3 text-success">Message sent successfully!</p>
      )}
      {status === "error" && (
        <p className="mt-3 text-danger">
          Error sending message. Please try again.
        </p>
      )}
    </div>
  );
}

export default ContactUs;
